import { render, staticRenderFns } from "./GoodsModal.vue?vue&type=template&id=499d7084&scoped=true"
import script from "./GoodsModal.vue?vue&type=script&lang=js"
export * from "./GoodsModal.vue?vue&type=script&lang=js"
import style0 from "./GoodsModal.vue?vue&type=style&index=0&id=499d7084&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d7084",
  null
  
)

export default component.exports